import { Condition } from '@staffino/model';
import { ConditionEvaluatorContext } from '../condition-evaluator-context';
import { InteractionObject } from '../../flow-bridge';

export async function interactionReason(
  condition: Condition,
  context: ConditionEvaluatorContext,
): Promise<boolean> {
  const { operator, value } = condition[1] ?? {};

  const interactionId: string = context.bridge.interactionId;
  const objects =
    interactionId &&
    (await context.bridge.load({
      objectType: 'interaction',
      id: interactionId,
    }));
  const interaction: InteractionObject = objects?.[0] as InteractionObject;

  if (operator === 'contains') {
    return value.includes(interaction?.reason);
  }
  if (operator === '!contains') {
    return !value.includes(interaction?.reason);
  }
}
